import axios from "axios";
// import { MessageBox, Message } from 'element-ui'
import { Message } from "element-ui";
import store from "@/store";
import router from "../router";
// import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 2000000 // request timeout
});
if (sessionStorage.getItem("iwrs_token")) {
  service.defaults.headers.common["Authorization"] = sessionStorage.getItem(
    "iwrs_token"
  );
}

let isRedirectingToLogin = false;

function redirectToLogin(message) {
  if (isRedirectingToLogin) return;
  isRedirectingToLogin = true;
  if (message) {
    Message({
      message,
      type: "error",
      duration: 3 * 1000
    });
  }
  sessionStorage.clear();
  store.dispatch("user/resetToken").finally(() => {
    const currentPath = router.currentRoute.fullPath;
    if (router.currentRoute.path !== "/login") {
      router.push(`/login?redirect=${encodeURIComponent(currentPath)}`);
    }
    // 允许后续再次触发（例如重新登录后又失效）
    setTimeout(() => {
      isRedirectingToLogin = false;
    }, 1500);
  });
}

// request interceptor
service.interceptors.request.use(
  config => {
    if (sessionStorage.getItem("iwrs_token")) {
      config.headers["Authorization"] = sessionStorage.getItem("iwrs_token");
    }
    // do something before request is sent
    const res_environment = window.sessionStorage.getItem("iwrs_environment");
    if (res_environment === "PROD") {
      config.baseURL = "/api2";
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (
      response.config.url.indexOf("/v1.0/iwrs/subject/export") !== -1 ||
      response.config.url.indexOf("/v1.0/iwrs/project_user/export") !== -1
    ) {
      //导出 要记录名字
      if (response.headers["content-disposition"]) {
        let filename = response.headers["content-disposition"].split(
          "filename="
        )[1];
        store.commit(
          "export_file/SETFILETYPE",
          response.headers["content-type"]
        );
        store.commit("export_file/SETFILENAME", decodeURI(filename));
      }
      return response.data;
    }
    const res = response.data;

    // if the custom code is not 20000, it is judged as an error.
    if (res.code === -10000) {
      redirectToLogin(res.msg || "登录已失效，请重新登录");
      return Promise.reject(new Error(res.msg || "Error"));
    } else if (res.code === 10008) {
      // 无权限
      Message({
        message: res.msg,
        type: "error",
        duration: 5 * 1000
      });
    } else {
      const { errcode, errmsg, ...data } = res;
      let result = {
        code: errcode === 200 ? 0 : errcode,
        success: errcode === 200 ? true : false,
        msg: errmsg,
        ...data
      };
      return result;
    }
  },

  error => {
    if (error.message === "Network Error") {
      Message({
        message: "网络错误，稍后再试",
        type: "error",
        duration: 3 * 1000
      });
      return Promise.reject(error);
    }
    const status = error.response && error.response.status;
    if (status === 401 || status === 403) {
      redirectToLogin("登录已失效，请重新登录");
      return Promise.reject(error);
    }
    Message({
      message:
        error.response && error.response.status === 400
          ? Object.values(error.response.data.message)[0]
          : error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
